import React, { useEffect, useState } from "react";
import { FaTimes, FaApple, FaDownload } from "react-icons/fa";
import "../styles/IosInstallModal.css";

const IosInstallModal = ({ onClose }) => {
    const [canInstall, setCanInstall] = useState(false);
    const [deferredPrompt, setDeferredPrompt] = useState(null);

    useEffect(() => {
        const handler = (e) => {
            e.preventDefault();
            setDeferredPrompt(e);
            setCanInstall(true);
        };
        window.addEventListener('beforeinstallprompt', handler);
        return () => window.removeEventListener('beforeinstallprompt', handler);
    }, []);

    const handleInstallClick = () => {
        if (deferredPrompt) {
            deferredPrompt.prompt();
            deferredPrompt.userChoice.then(() => {
                setDeferredPrompt(null);
                setCanInstall(false);
            });
        }
    };

    const handleOverlayClick = (e) => {
        if (e.target === e.currentTarget) {
            onClose();
        }
    };

    return (
        <div className="ios-install-modal-overlay" onClick={handleOverlayClick}>
            <div className="ios-install-modal">
                <div className="ios-install-modal-header">
                    <div className="ios-install-modal-title">
                        <FaApple className="ios-install-modal-icon" />
                        <span>Установка на iPhone (iOS)</span>
                    </div>
                    <button className="ios-install-modal-close" onClick={onClose}>
                        <FaTimes />
                    </button>
                </div>

                <div className="ios-install-modal-content">
                    <div className="ios-install-modal-description">
                        Добавьте ONCASPIN на главный экран вашего iPhone, чтобы всегда иметь быстрый доступ к любимым играм!
                        <div className="ios-install-modal-bonus">
                            <span className="bonus-text">🎁 Бонус 200₽</span> за установку ярлыка!
                        </div>
                    </div>

                    {canInstall && (
                        <div className="ios-install-modal-auto-install">
                            <button
                                className="ios-install-modal-install-btn"
                                onClick={handleInstallClick}
                            >
                                <FaDownload />
                                Установить на устройство
                            </button>
                            <div className="ios-install-modal-install-note">
                                После установки ярлык появится в меню Пуск и вы сможете закрепить его на панели задач (ПК) или на главном экране (Android).
                            </div>
                        </div>
                    )}

                    <div className="ios-install-modal-steps">
                        <h3 className="ios-install-modal-steps-title">Пошаговая инструкция:</h3>

                        <div className="ios-install-modal-steps-container">
                            <div className="ios-install-modal-step">
                                <div className="ios-install-modal-step-number">1</div>
                                <div className="ios-install-modal-step-content">
                                    <img src="/assets/ios-instruction/1.png" alt="Шаг 1" />
                                    <p>При заходе на сайт с iOS устройства, вам нужно нажать на кнопку <strong>поделиться</strong> внизу экрана</p>
                                </div>
                            </div>

                            <div className="ios-install-modal-step">
                                <div className="ios-install-modal-step-number">2</div>
                                <div className="ios-install-modal-step-content">
                                    <img src="/assets/ios-instruction/2.png" alt="Шаг 2" />
                                    <p>Далее выбираете <strong>"На экран Домой"</strong></p>
                                </div>
                            </div>

                            <div className="ios-install-modal-step">
                                <div className="ios-install-modal-step-number">3</div>
                                <div className="ios-install-modal-step-content">
                                    <img src="/assets/ios-instruction/3.png" alt="Шаг 3" />
                                    <p>Нажимаете <strong>"Добавить"</strong></p>
                                </div>
                            </div>

                            <div className="ios-install-modal-step">
                                <div className="ios-install-modal-step-number">4</div>
                                <div className="ios-install-modal-step-content">
                                    <img src="/assets/ios-instruction/4.png" alt="Шаг 4" />
                                    <p>У вас появился ярлык с доступом к сайту</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="ios-install-modal-benefits">
                        <h3>Зачем это нужно?</h3>
                        <ul>
                            <li>🚀 Быстрый доступ к казино без поиска в браузере</li>
                            <li>🔔 Уведомления и акции прямо на вашем устройстве</li>
                            <li>⚡ Установка занимает 10 секунд!</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default IosInstallModal; 